import { innovationIcon } from '@/uiIcons/innovationIcon.css';
import { toolBlockIcon } from '@/uiIcons/toolBlockIcon.css';
import { warningIcon } from '@/uiIcons/warningIcon.css';
import { typeGuard } from 'tsafe';

export const asideBlockTypes = {
	tip: innovationIcon,
	important: warningIcon,
	tool: toolBlockIcon,
} as const;

export type AsideBlockTypeKey = keyof typeof asideBlockTypes;

export const isAsideBlockTypeKey = (
	value: string | undefined,
): value is AsideBlockTypeKey => {
	return typeGuard<AsideBlockTypeKey>(
		value,
		value != null && value in asideBlockTypes,
	);
};
